import styled from 'styled-components';
import {
  space,
  layout,
  color,
  flexbox,
  position,
  border,
  shadow,
  grid,
} from 'styled-system';

const Box = styled.div(
  space,
  layout,
  color,
  flexbox,
  position,
  border,
  shadow,
  grid
);

export default Box;
